"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _common = require("../../common");

require("./styles.css");

var _constants = require("../../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PopupContent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PopupContent, _PureComponent);

  function PopupContent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PopupContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PopupContent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getOffset", function (direction) {
      var offset = _this.props.offset;

      if ((0, _lib.objKeysHasValue)(offset)) {
        offset = offset[direction];
      }

      if ((0, _lib.isNumber)(offset)) {
        return "".concat(offset, "%");
      }

      return offset;
    });

    _defineProperty(_assertThisInitialized(_this), "setMarginOffset", function (direction) {
      var value = _this.getOffset(direction);

      if (value) {
        // NOTE: removed negative value for now
        // if (value.includes('-')) {
        //   value = value.substring(1, value.length);
        // }
        var opposite = (0, _lib.getOppositeDirection)(direction);
        return {
          name: "margin".concat((0, _lib.uppercaseFirstLetter)(opposite)),
          value: value
        };
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getStyle", function () {
      var _this$props = _this.props,
          offset = _this$props.offset,
          direction = _this$props.direction,
          style = _this$props.style;
      var offsetStyle = {};

      if (offset) {
        var dir;

        if ((0, _lib.arrayHasItems)(direction)) {
          dir = direction[0];
        } else if ((0, _lib.isStringMatch)(direction, _constants.DIRECTION_ALL)) {
          dir = direction;
        }

        if (dir) {
          var offsetKey = _this.setMarginOffset(dir);

          if (offsetKey) {
            var name = offsetKey.name,
                value = offsetKey.value;
            offsetStyle[name] = value;
          }
        }
      }

      return Object.assign({}, offsetStyle, style && style);
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['visible', 'disabled'];
      var names = [PopupContent.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      var _this$props2 = _this.props,
          direction = _this$props2.direction,
          oneSide = _this$props2.oneSide;

      _common.customClassNames.addDirection(names, direction, oneSide);

      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          onClick = _this$props3.onClick;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (onClick) {
        onClick(e);
      }
    });

    return _this;
  }

  _createClass(PopupContent, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          as = _this$props4.as,
          children = _this$props4.children,
          visible = _this$props4.visible,
          direction = _this$props4.direction,
          offset = _this$props4.offset,
          onClick = _this$props4.onClick,
          rounded = _this$props4.rounded,
          style = _this$props4.style,
          oneSide = _this$props4.oneSide,
          rest = _objectWithoutProperties(_this$props4, ["as", "children", "visible", "direction", "offset", "onClick", "rounded", "style", "oneSide"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      var styles = this.getStyle();
      return _react["default"].createElement(Wrapper, _extends({}, rest, {
        style: styles,
        className: classNames,
        onClick: this.handleOnClick
      }), children);
    }
  }]);

  return PopupContent;
}(_react.PureComponent);

exports["default"] = PopupContent;

_defineProperty(PopupContent, "className", 'MHub-Popup-Content');

_defineProperty(PopupContent, "displayName", 'PopupContent');

_defineProperty(PopupContent, "propTypes", {
  as: _common.customPropTypes.as,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  visible: _propTypes["default"].bool,
  direction: _propTypes["default"].oneOfType([_common.customPropTypes.directionAll, _propTypes["default"].arrayOf(_common.customPropTypes.directionAll)]),
  offset: _propTypes["default"].oneOfType([_common.customPropTypes.stringOrNumber, _propTypes["default"].shape({
    top: _common.customPropTypes.stringOrNumber,
    bottom: _common.customPropTypes.stringOrNumber,
    left: _common.customPropTypes.stringOrNumber,
    right: _common.customPropTypes.stringOrNumber
  })]),
  rounded: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  style: _propTypes["default"].shape({}),
  oneSide: _propTypes["default"].bool
});

_defineProperty(PopupContent, "defaultProps", {
  as: null,
  className: null,
  visible: false,
  direction: 'bottom',
  offset: null,
  rounded: false,
  disabled: false,
  onClick: null,
  style: null,
  oneSide: false
});